import type { PropType } from 'vue'
import type { ValidationValue } from '../OenUiInputValidation/types'

export const analyticsNameProp = {
  analyticsName: {
    type: String,
    required: false,
    default: '',
  },
}
export const validationProp = {
  validation: {
    type: Object as PropType<ValidationValue<unknown>>,
    required: false,
    default: () => ({}),
  },
}
export const requiredValidationProp = {
  validation: {
    type: Object as PropType<ValidationValue<unknown>>,
    required: true,
  },
}
